/**
 * costs.ts — Firestore helpers for reading per-user daily API costs.
 *
 * Data model:
 *   users/{uid}/costs/{YYYY-MM-DD} → { chat, debate, total, updatedAt }
 *
 * The backend writes these docs; the frontend only reads.
 */

import { doc, onSnapshot, Unsubscribe } from "firebase/firestore";
import { db } from "./config";

export interface DailyCost {
  chat: number;
  debate: number;
  total: number;
}

const EMPTY: DailyCost = { chat: 0, debate: 0, total: 0 };

function todayKey(): string {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD
}

/** Subscribe to real-time updates of today's cost for a user. */
export function onTodayCostSnapshot(
  uid: string,
  callback: (cost: DailyCost) => void,
): Unsubscribe {
  const ref = doc(db, "users", uid, "costs", todayKey());
  return onSnapshot(
    ref,
    (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        callback({
          chat: data.chat || 0,
          debate: data.debate || 0,
          total: data.total || 0,
        });
      } else {
        callback({ ...EMPTY });
      }
    },
    () => {
      // On error (permissions, etc.) return zeros silently
      callback({ ...EMPTY });
    },
  );
}
